import lottie from 'lottie';

class LottieAnimation {


    constructor(element, options) {

        this.element = element;

        if(options.path){
            this.path = options.path;
        } else {
            this.path = "animations/" + options.name + ".json";
        }
        
        this.renderer = options.renderer;
        this.autoplay = options.autoplay;
        this.name = options.name;
        this.loop = options.loop;
        this.delay = options.delay;

        this.init();
    }

    

    init() {

        var self = this;

        lottie.loadAnimation({
            container: self.element,
            renderer: self.renderer,
            loop: self.loop,
            autoplay: false, //always false, use delay logic
            name: self.name,
            path: self.path
        });

        if(this.autoplay)
        {
            setTimeout(this.play, this.delay);  
        }

    }

    play() {
        lottie.play(this.name);
    }

}


LottieAnimation.DEFAULTS = {
    loop : false,
    autoplay : true,
    renderer : "svg"
};

export default LottieAnimation;


// WEBPACK FOOTER //
// ./project/client/src/core/components/lottieAnimation/lottieAnimation.js